/**
 * Created by zzy on 2019/8/5.
 */
import VehiclePassRecords from './VehiclePassRecords.vue'
export default VehiclePassRecords



// WEBPACK FOOTER //
// ./src/views/events/VehiclePassRecords/index.js